import { CopyOutlined } from '@ant-design/icons'
import { Collapse, Tag } from 'antd'
import React, { FunctionComponent } from 'react'

export interface AuctionMonitoringLinkedPropertyHelpProps {
  defaultActiveKey?: string
}

const { Panel } = Collapse

export const AuctionMonitoringLinkedPropertyHelp: FunctionComponent<AuctionMonitoringLinkedPropertyHelpProps> =
  props => {
    return (
      <Collapse accordion defaultActiveKey={props.defaultActiveKey}>
        <Panel header="K čemu slouží přiřazování nemovitostí?" key="purpose">
          <div className="space-y-4">
            <p>
              Párování napomáhá <strong>snadnější správě</strong> obchodních
              případů a usnadňuje práci s poznámkami, štítky, hromadnou poštou
              ad.
            </p>
            <p>
              Přiřazení dotčené nemovitosti k dražbě umožňuje zobrazovat{' '}
              <strong>podrobné informace o nemovitosti</strong> přímo v
              tabulkových přehledech i detailu dražby a stejně tak{' '}
              <strong>podrobné informace o dražbě</strong> přímo v detailu
              nemovitosti, kde po přiřazení přibude nová karta „Dražba“.
            </p>
            <p>
              K dražbě můžete přiřadit <strong>libovolný počet</strong>{' '}
              nemovitostí, stejně tak můžete jednu nemovitost přiřadit k více
              dražbám.
            </p>
          </div>
        </Panel>

        <Panel header="Přiřazení pomocí URL" key="url">
          <ol className="list-decimal list-outside space-y-2 pl-4">
            <li>
              <strong>Vyhledejte</strong> konkrétní nemovitost v naší aplikaci
              (nejlépe v nové záložce prohlížeče), kterou chcete propojit s
              dražbou a přejděte do jejího detailu.
            </li>
            <li>
              Z adresního řádku prohlížeče nebo kliknutím na ikonu{' '}
              <CopyOutlined /> v drobečkové navigaci (nad názvem nemovitosti){' '}
              <strong>zkopírujte URL</strong> adresu (odkaz).
            </li>
            <li>
              <strong>Vložte URL</strong> adresu do formulářového pole a
              počkejte až se zobrazí kontrolní náhled nemovitosti.
            </li>
            <li>
              Pokud je vše v pořádku, klikněte na tlačítko{' '}
              <strong>Přiřadit nemovitost</strong>.
            </li>
          </ol>
        </Panel>

        <Panel
          header="Přiřazení pomocí mapy"
          key="map"
          extra={
            <Tag color="blue" className="text-xs">
              Doporučeno
            </Tag>
          }
        >
          <div className="space-y-4">
            <p>
              V mapovém zobrazení{' '}
              <strong>není potřeba vyhledávat a kopírovat odkaz</strong> na
              detail nemovitosti, párování probíhá přímo výběrem konkrétních
              parcel či budov v mapě. Poloha dražby zpravidla odpovídá umístění
              nemovitosti.
            </p>
            <ol className="list-decimal list-outside space-y-2 pl-6">
              <li>
                V mapě <strong>vyberte dražbu</strong> a kliknutím otevřete její
                detail v postranním panelu.
              </li>
              <li>
                Vpravo dole v postranním panelu klikněte na tlačítko{' '}
                <strong>Přidat nemovitosti k dražbě</strong>. Tím se aktivuje
                režim pro párování nemovitostí. V tomto režimu můžete opětovně
                klikat do mapy, aniž by se zavřel postranní panel detailu
                dražby.
              </li>
              <li>
                Výběrem konkrétní parcely nebo budovy se v druhém postranním
                panelu zobrazí její detail, kde můžete zkontrolovat, zda se
                jedná o správnou nemovitost. Pokud ano, klikněte na tlačítko{' '}
                <strong>Přidat nemovitost</strong>, změna se okamžitě projeví v
                detailu dražby.
              </li>
              <li>
                Můžete <strong>pokračovat v přidávání</strong> dalších
                nemovitostí stejným způsobem nebo kliknout na tlačítko{' '}
                <strong>Ukončit přidávání</strong>, čímž se vrátíte zpět do
                běžného režimu prohlížení mapy.
              </li>
            </ol>
            <p>
              V mapě bohužel <strong>nelze vybírat konkrétní jednotky</strong> v
              budovách (byty, studia, nebytové prostory...), pro zařazení
              jednotky do dražby je proto nutné použít metodu párování{' '}
              <strong>pomocí URL</strong> odkazu na detail nemovitosti.
            </p>
          </div>
        </Panel>

        <Panel header="Lze přiřazení odebrat?" key="remove">
          <div className="space-y-4">
            <p>
              Přiřazenou nemovitost k dražbě <strong>lze</strong> kdykoliv
              odebrat, přičemž tato akce nemá vliv na samotnou nemovitost
              (poznámky, štítky...), pouze se odstraní vazba mezi dražbou a
              nemovitostí.
            </p>
            <p>
              Pokud k tomu nemáte důvod, <strong>není nutné</strong> po skončení
              dražby vazby na nemovitosti odstraňovat.
            </p>
          </div>
        </Panel>

        <Panel header="Proč je nutné nemovitosti párovat ručně?" key="reason">
          <p>
            Jsme si vědomi, že manuální párování není uživatelsky přívětivá
            akce, bohužel však dražební{' '}
            <strong>portály neuveřejňují dostatek informací</strong>, abychom
            dokázali s jistotou určit, které konkrétní nemovitosti do dražby
            spadají. Z toho důvodu jsme byli nuceni ponechat alespoň pouze
            možnost ručního párování.
          </p>
        </Panel>
      </Collapse>
    )
  }
